import { PaymentUtilService } from './../../services/payment-util/payment-util.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICart } from '../../models/cart.model';
import { UtilService, VariablesService } from '../../../../shared/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-wallets',
  templateUrl: './wallets.component.html',
  styleUrls: ['./wallets.component.scss']
})
export class WalletsComponent implements OnInit {

  @Input() option;
  @Input() topWallets;
  @Input() cartDetails: ICart;
  @Input() isOrderLoading;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  selectedWallet;
  walletForm: FormGroup;
  walletName: FormControl;
  constructor(
    private utilService: UtilService,
    public paymentUtilService: PaymentUtilService,
    public vars: VariablesService
  ) { }

  ngOnInit() {
    this.walletForm = new FormGroup({
      walletName: this.walletName = new FormControl('', [Validators.required])
    });
  }
  /**Get the keys of bank list object */
  getWalletNames(data) {
    return data ? this.utilService.sortArray(Object.keys(data)) : null;
  }
  selectWallet(name) {
    this.selectedWallet = name;
    this.walletName.setValue(name);
  }
  /**On click event of top banks */
  submitWallet() {
    if (this.walletForm.valid) {
      const data = {
        'mode': 'WALLET',
        'mode_value': this.walletName.value,
      };
      this.dataEmit.emit(data);
    } else {
      this.utilService.checkValidForm(this.walletForm);
    }
  }
}
